// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
var spawnAff = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var bind = Control_Bind.bind((MonadCleanup1.Monad0()).Bind1());
    var liftEffect = Effect_Class.liftEffect(dictMonadFRP.MonadEffect0());
    var onCleanup = Control_Monad_Cleanup.onCleanup(MonadCleanup1);
    return function (task) {
        return bind(liftEffect(Effect_Aff.launchAff(task)))(function (fiber) {
            return onCleanup(Effect_Aff.launchAff_(Effect_Aff.killFiber(Effect_Exception.error("Cancelled"))(fiber)));
        });
    };
};
export {
    nextMicrotask
} from "./foreign.js";
export {
    spawnAff
};
